import * as React from "react"
import Slider from "react-slick"
import estates from "../../assets/json/estates/estates.json"
import Empty from "../../assets/images/empty.svg"

const SliderLogo = ({ pageContext: { translate } }) => {
  var settings = {
    slidesToShow: 8,
    centerPadding: "24px",
    arrows: true,
    doys: false,
    infinite: false,
    speed: 500,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1270,
        settings: {
          slidesToShow: 8,
          initialSlide: 0,
        },
      },
      {
        breakpoint: 1140,
        settings: {
          slidesToShow: 6,
          initialSlide: 0,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 5,
          initialSlide: 0,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
          initialSlide: 0,
        },
      },
    ],
  }

  return (
    <>
      {
        <div className="slider-roster">
          <div className="content">
            <div className="pb-5">
              <h2>{translate.t?.visit_our_estates}</h2>
            </div>
            <Slider {...settings}>
              {Array.isArray(estates) &&
                estates.map(item => (
                  <>
                    <a
                      href={`${process.env.GATSBY_SITE_URL}/estate/${item.slug}`}
                      target="_blank"
                    >
                      <img
                        className={`img-fluid ${
                          item.company_image_thumbnail_url ? "" : "p-4 bg-eb"
                        }`}
                        src={item.company_image_thumbnail_url || Empty}
                        alt={item.company_name}
                      />
                    </a>{" "}
                  </>
                ))}
            </Slider>
          </div>
        </div>
      }
    </>
  )
}

export default SliderLogo
